// Zavírání oken klikem na tmavé pozadí (rozhodnutí zadavatele 27. 10. 2026: „když vyjedu ven z okna, tak spadne a musím
// ho otevřít znovu — ochraň to proti zavírání“). Pravidlo pro celou aplikaci:
//
//   (a) **Okno s formulářem se klikem na pozadí nezavírá nikdy** — jen křížkem, tlačítkem Zrušit nebo Escape.
//       Klikem na pozadí se zavírají jen okna bez polí (náhled, potvrzení bez důvodu).
//   (b) I tam se okno zavře jen tehdy, když stisk myši **začal i skončil na pozadí**. Stisk uvnitř okna (označování
//       textu v poli, posouvání, tažení posuvníku) a puštění venku prohlížeč ohlásí jako `click` na pozadí — bez této
//       kontroly by okno zavřel a rozepsaný text zmizel.
//
// Použití: `<div className="prekryv" {...usePodklad(klikemMimo ? naZavrit : null)}>`; `null` = okno klikem nezavřít.
import { type MouseEvent, useRef } from 'react';

export interface ObsluhaPodkladu {
  onMouseDown?: (u: MouseEvent<HTMLElement>) => void;
  onMouseUp?: (u: MouseEvent<HTMLElement>) => void;
  onClick?: (u: MouseEvent<HTMLElement>) => void;
}

/**
 * Obsluha pozadí okna. `zavrit` = co se stane po „čistém“ kliknutí na pozadí (stisk i puštění na pozadí);
 * `null`/`undefined` = pozadí okno nezavírá (okno s formulářem).
 */
export function usePodklad(zavrit: (() => void) | null | undefined): ObsluhaPodkladu {
  // Kde stisk začal a kde skončil: jen `true` + `true` je klik, který patří pozadí.
  const stisk = useRef<{ zacatek: boolean; konec: boolean }>({ zacatek: false, konec: false });
  const zavritRef = useRef(zavrit);
  zavritRef.current = zavrit;
  if (!zavrit) return {};
  return {
    onMouseDown: (u) => {
      stisk.current = { zacatek: u.target === u.currentTarget, konec: false };
    },
    onMouseUp: (u) => {
      stisk.current.konec = u.target === u.currentTarget;
    },
    onClick: (u) => {
      const { zacatek, konec } = stisk.current;
      stisk.current = { zacatek: false, konec: false };
      if (u.target !== u.currentTarget || !zacatek || !konec) return;
      zavritRef.current?.();
    },
  };
}
